import { useState } from "react"
import Title from "../components/ui/Title"
import '../styles/pages/field.scss'

const FieldNotes = () => {
    
    const [section, updateSection]  = useState(0)

    const changeSection = (sectionNumber) => (
        updateSection(sectionNumber)
    )
    
    return (
        <div className="page-container">
            <Title text="SSS Field Notes" size="full"/>
            <div className="tablist-wrapper">
                <h1>Sections</h1>
                <TabList updateSection={changeSection}/>
            </div>
            <div className="line-container">
            {
                section === 0 ? <FieldSummaryHacked/> :
                section === 1 ? <BracerGuildHacked/> :
                section === 2 ? <TestamentsHacked/> :
                section === 3 ? <SaberVipersHacked/> :
                section === 4 ? <Revache/> : <Heiyue/>
            }
            </div>
        </div>
    )
}


const TabList = ({updateSection}) => (
    <ul className="tab-list">
        <li className="tab-link hacked" onClick={()=>{
            updateSection(0)
        }}>
            Summary
        </li>
        <li className="tab-link hacked" onClick={()=>{
            updateSection(1)
        }}>
            Bracer Guild
        </li>
        <li className="tab-link hacked" onClick={()=>{
            updateSection(2)
        }}>
            Testaments
        </li>
        <li className="tab-link hacked" onClick={()=>{
            updateSection(3)
        }}>
            Saber Vipers
        </li>

                
        <li className="tab-link hacked" onClick={()=>{
            updateSection(4)
        }}>
            Revache
        </li>
        {

        <li className="tab-link hacked" onClick={()=>{
            updateSection(5)
        }}>
            Heiyue
        </li>
        /*
        <li className="tab-link hacked" onClick={()=>{
            updateSection(6)
        }}>
            Summary (Hacked)
        </li>
        <li className="tab-link hacked" onClick={()=>{
            updateSection(7)
        }}>
            Bracer Guild (Hacked)
        </li>
        <li className="tab-link hacked" onClick={()=>{
            updateSection(8)
        }}>
            Testaments (Hacked)
        </li>
        <li className="tab-link hacked" onClick={()=>{
            updateSection(9)
        }}>
            <span className="grey">Saber Vipers (Hacked)</span>
        </li>
            */
        }
    </ul>
)

/*

const FieldSummary = () => (
    <>
        <h1 className="summary-title">
            SSS Field Notes
        </h1>
        <h2 className="summary-title_caption">
            As written by Lloyd Bannings
        </h2>
        <div className="sss-container">
            <img style={{padding: "50px 0px", maxHeight: "500px"}} src="./img/sss-emblem.webp" alt="SSS Emblem" />
            <div className="sss-team">
                <img className="notes-chracter-image" style={{maxHeight: "200px"}} src="./img/characters/lloyd.webp" alt="Key art of Lloyd" />
                <img className="notes-chracter-image" style={{maxHeight: "200px"}} src="./img/characters/elie.webp" alt="Key art of Elie" />
                <img className="notes-chracter-image" style={{maxHeight: "200px"}} src="./img/characters/tio.webp" alt="Key art of Tio" />
                <img className="notes-chracter-image" style={{maxHeight: "200px"}} src="./img/characters/randy.webp" alt="Key art of Randy" />
            </div>
        </div>
        <div className="summary-container">
            <p>
                While far from complete, these field notes are a way for the SSS to catalog our intel regarding the organizations, criminal or otherwise, that inhabit Crossbell City. As we learn more about these different groups, we will add to these notes in order to support our efforts in assisting the citizens of this city.    
            </p>
            <p>
                Information is still being obtained and all notes are subject to review by Section Chief Sergei Lou (even if he insists that he doesn’t want or need to do so).
            </p>
        </div>
    </>
)

const BracerGuild = () => (
    <>
        <h1 className="summary-title">
            Bracer Guild
        </h1>
        <div className="summary-characters">
            <img className="notes-character-image" style={{maxHeight: "250px"}} src="./img/characters/arios.webp" alt="Key art of Arios" />
            <img className="notes-character-image" style={{maxHeight: "250px"}} src="./img/characters/estelle.webp" alt="Key art of Estelle" />
            <img className="notes-character-image" style={{maxHeight: "250px"}} src="./img/characters/joshua.webp" alt="Key art of Joshua" />
        </div>
        <div className="summary-container">
            <p>
                An international non-governmental organization with branches all across the continent, the Bracer Guild’s goal is to keep the peace and protect civilians. As this overlaps with our own directives somewhat, they could be seen as the biggest competitor to the SSS. Although to be honest, this rivalry is a bit one-sided in the Bracer Guild’s favor at the moment... 
            </p>
            <p>
                Due to the stellar track record of their Crossbell branch and the impeccable work of the internationally-famous bracer, Arios MacLaine, the Bracer Guild has become the first group citizens will turn to when they’re in need of help. Two new transfers include Estelle and Joshua Bright. 
            </p>
        </div>
    </>
)

const Testaments = () => (
    <>
        <h1 className="summary-title">
            Testaments
        </h1>
        <img className="notes-character-image" style={{maxHeight: "250px"}} src="./img/characters/wazy.webp" alt="Key art of Wazy" />
        <div className="summary-container">
            <p>
                A group of delinquents located in the Downtown District of Crossbell City, the Testaments fancy themselves as intellectuals. Their calm and collected leader, Wazy Hemisphere, has earned himself quite the loyal following, one that the SSS will need to monitor closely moving forward.
            </p>
            <p>
                It seems the Trinity bar is the Testament’s base of operations, and they refer to this location as their “holy ground.” Not exactly the words I’d use to describe a bar, but it does track with the religious motif this group has adopted. 
            </p>
            <p>
                The group has a bitter rivalry with the Saber Vipers, with the two gangs often finding any excuse to go at it. It often ends up falling on us to put a stop to things before any innocent bystanders get hurt.
            </p>
        </div>
    </>
)

const SaberVipers = () => (
    <>
        <h1 className="summary-title">
            Saber Vipers
        </h1>
        <img className="notes-character-image" style={{maxHeight: "250px"}} src="./img/characters/wald.webp" alt="Key art of Wald" />
        <div className="summary-container">
            <p>
                A group of delinquents located in the Downtown District of Crossbell City, the Saber Vipers are very rough around the edges. Its members are almost always looking for a fight, due in large part to their hot-headed leader, Wald Wales. That being said, he may be the only one strong enough to keep a group like this in line.
            </p>
            <p>
                The Saber Vipers have occupied an abandoned warehouse named Ignis, and have been using it as their headquarters. The loud music being blasted from the building during all hours of the day is fairly unmistakable…
            </p>
            <p>
                The group has a bitter rivalry with the Testaments, with the two gangs often finding any excuse to go at it. It often ends up falling on us to put a stop to things before any innocent bystanders get hurt.
            </p>
        </div>
    </>
)
*/


const FieldSummaryHacked = () => (
        <div className="hacked-wrapper">
            <div className="hacked-title_wrapper">
                <img className="dance" src="./img/field/bunny.webp" alt="Stuff Bunny" />
                <h1 className="hacked-title" style={{textAlign: "center"}}>
                    Summary
                </h1>
                <img className="dance" src="./img/field/cat.webp" alt="Stuff Bunny" />
            </div>
            <div className="sss-container">
                <img style={{padding: "50px 0px", maxHeight: "500px"}} src="./img/sss-emblem.webp" alt="SSS Emblem" />
                <div className="sss-team">
                    <img className="notes-chracter-image pink" style={{maxHeight: "200px"}} src="./img/characters/lloyd-cat.webp" alt="Key art of Lloyd" />
                    <img className="notes-chracter-image pink" style={{maxHeight: "200px"}} src="./img/characters/elie-cat.webp" alt="Key art of Elie" />
                    <img className="notes-chracter-image pink" style={{maxHeight: "200px"}} src="./img/characters/tio-cat.webp" alt="Key art of Tio" />
                    <img className="notes-chracter-image pink" style={{maxHeight: "200px"}} src="./img/characters/randy-cat.webp" alt="Key art of Randy" />
                </div>
            </div>
            <h2 className="summary-title_caption">
                <span className="strike">
                    As written by Lloyd Bannings
                </span><br/>
                <span data-text="Edited by Kitty" className="kitty glitch">
                    Edited by Kitty
                </span>
                <br/>
                <img className="kitty-logo" src="./img/field/kitty.webp" alt="Kitty Sign" />
            </h2>
            <div className="summary-container">
                <p>
                    While far from complete, these field notes are a way for the SSS to catalog our intel regarding the organizations, criminal or otherwise, that inhabit Crossbell City. As we learn more about these different groups,
                    <span className="strike">
                        we will add to these notes in order to support our efforts in assisting the citizens of this city. 
                    </span>
                    <span className="kitty">
                        I will be supplementing these notes with my own information. Think of it as my little gift to a group of rookies that are clearly in over their heads. 
                    </span>
                </p>
                <p>
                    Information is still being obtained and all notes are subject to review by Section Chief Sergei Lou
                    <span className="strike">
                    (even if he insists that he doesn’t want or need to do so).
                    </span>
                    <span className="kitty">
                        This is assuming he’ll take the time to read them, which I truly doubt.
                    </span>
                </p>
            </div>`
        </div>
)

const BracerGuildHacked = () => (
    <div className="hacked-wrapper">
        <div className="hacked-title_wrapper">
            <img className="dance" src="./img/field/cat.webp" alt="Stuff Bunny" />
            <h1 className="hacked-title" style={{textAlign: "center"}}>
                Bracer Guild
            </h1>
            <img className="dance" src="./img/field/bunny.webp" alt="Stuff Bunny" />
        </div>
        <div className="summary-characters">
            <img className="notes-character-image pink" style={{maxHeight: "250px"}} src="./img/characters/arios.webp" alt="Key art of Arios" />
            <img className="notes-character-image pink" style={{maxHeight: "250px"}} src="./img/characters/estelle.webp" alt="Key art of Estelle" />
            <img className="notes-character-image pink" style={{maxHeight: "250px"}} src="./img/characters/joshua.webp" alt="Key art of Joshua" />
        </div>
        <h2 className="summary-title_caption">
            <span data-text="Edited by Kitty" className="kitty glitch">
                Edited by Kitty
            </span>
            <br/>
            <img className="kitty-logo" src="./img/field/kitty.webp" alt="Kitty Sign" />
        </h2>
        <div className="summary-container">
            <p>
                An international non-governmental organization with branches all across the continent, the Bracer Guild’s goal is to keep the peace and protect civilians. As this overlaps with our own directives somewhat, they could be seen as the biggest competitor to the SSS. Although to be honest, this rivalry is a bit one-sided in the Bracer Guild’s favor at the moment...
                <span className="kitty">
                    I must commend Lloyd for his honesty in this matter. However, calling the rivalry “one-sided” is a gross understatement. Perhaps even calling it a “rivalry” at all is too much.
                </span>
            </p>
            <p>
                Due to the stellar track record of their Crossbell branch and the impeccable work of the internationally-famous bracer, Arios MacLaine, the Bracer Guild has become the first group citizens will turn to when they’re in need of help. Two new transfers include Estelle and Joshua Bright.
                <span className="kitty">
                    My, these two certainly are persistent…
                </span>
            </p>
        </div>
    </div>
)

const TestamentsHacked = () => (
    <div className="hacked-wrapper">
        <div className="hacked-title_wrapper">
            <img className="dance" src="./img/field/bunny.webp" alt="Stuff Bunny" />
            <h1 className="hacked-title" style={{textAlign: "center"}}>
                Testaments
            </h1>
            <img className="dance" src="./img/field/cat.webp" alt="Stuff Bunny" />
        </div>
        <img className="notes-character-image pink" style={{maxHeight: "250px"}} src="./img/characters/wazy.webp" alt="Key art of Wazy" />
        <h2 className="summary-title_caption">
            <span data-text="Edited by Kitty" className="kitty glitch">
                Edited by Kitty
            </span>
            <br/>
            <img className="kitty-logo" src="./img/field/kitty.webp" alt="Kitty Sign" />
        </h2>
        <div className="summary-container">
            <p>
                A group of delinquents located in the Downtown District of Crossbell City, the Testaments fancy themselves as intellectuals. Their calm and collected leader, Wazy Hemisphere, has earned himself quite the loyal following
                <span className="kitty">
                    (as well as some emotionally unstable fan girls), 
                </span>
                 one that the SSS will need to monitor closely moving forward.
                <span className="kitty">
                    I believe there is far more to Wazy than meets the eye. However, I doubt any of his followers can see past his facade.
                </span>
            </p>
            <p>
                It seems the Trinity bar is the Testament’s base of operations, and they refer to this location as their “holy ground.” Not exactly the words I’d use to describe a bar, but it does track with the religious motif this group has adopted. 
            </p>
            <p>
                The group has a bitter rivalry with the Saber Vipers, with the two gangs often finding any excuse to go at it. It often ends up falling on us to put a stop to things before any innocent bystanders get hurt.
                <span className="kitty">
                    This raises the question; who shall put a stop to things should the SSS get hurt in the process? Perhaps the Bracer Guild can come to the rescue when this inevitable outcome occurs.
                </span>
            </p>
        </div>
    </div>
)

const SaberVipersHacked = () => (
    <div className="hacked-wrapper">
        <div className="hacked-title_wrapper">
            <img className="dance" src="./img/field/cat.webp" alt="Stuff Bunny" />
            <h1 className="hacked-title" style={{textAlign: "center"}}>
                Saber Vipers
            </h1>
            <img className="dance" src="./img/field/bunny.webp" alt="Stuff Bunny" />
        </div>
        <img className="notes-character-image pink" style={{maxHeight: "250px"}} src="./img/characters/wald.webp" alt="Key art of Wald" />
        <h2 className="summary-title_caption">
            <span data-text="Edited by Kitty" className="kitty glitch">
                Edited by Kitty
            </span>
            <br/>
            <img className="kitty-logo" src="./img/field/kitty.webp" alt="Kitty Sign" />
        </h2>
        <div className="summary-container">
            <p>
                A group of delinquents located in the Downtown District of Crossbell City, the Saber Vipers are very rough around the edges. Its members are almost always looking for a fight, due in large part to their hot-headed
                <span className="kitty">
                (not to mention single-minded, obstinate, and childish) 
                </span>
                 leader, Wald Wales. That being said, he may be the only one strong enough to keep a group like this in line.
                <span className="kitty">
                I for one won’t give Wald too much credit, as dangling something shiny in front of their eyes is likely all it takes to keep his followers in check.
                </span>
            </p>
            <p>
                The Saber Vipers have occupied an abandoned warehouse named Ignis, and have been using it as their headquarters. The loud music being blasted from the building during all hours of the day is fairly unmistakable…
                <span className="kitty">
                    I guess it’s true that small dogs bark the loudest.
                </span>
            </p>
            <p>
                The group has a bitter rivalry with the Testaments, with the two gangs often finding any excuse to go at it. It often ends up falling on us to put a stop to things before any innocent bystanders get hurt.
                <span className="kitty">
                    This begs the question; who shall put a stop to things should the SSS get hurt in the process? Perhaps the Bracer Guild can come to the rescue when this inevitable outcome occurs.
                </span>
            </p>
        </div>
    </div>
)

const Revache = () => (
    <div className="hacked-wrapper">
        <div className="hacked-title_wrapper">
            <img className="dance" src="./img/field/bunny.webp" alt="Stuff Bunny" />
            <h1 className="hacked-title" style={{textAlign: "center"}}>
                Revache
            </h1>
            <img className="dance" src="./img/field/cat.webp" alt="Stuff Bunny" />
        </div>
        <div className="summary-characters">
            <img className="notes-character-image pink" style={{maxHeight: "250px"}} src="./img/characters/don.webp" alt="Key art of MArconi" />
            <img className="notes-character-image pink" style={{maxHeight: "250px"}} src="./img/characters/garcia.webp" alt="Key art of Garcia" />
        </div>
        <h2 className="summary-title_caption">
            <span data-text="As written by Kitty" className="kitty glitch">
                As written by Kitty
            </span>
            <br/>
            <img className="kitty-logo" src="./img/field/kitty.webp" alt="Kitty Sign" />
        </h2>
        <div className="summary-container">
            <p>
                Revache is an influential mafia organization that has controlled the black market of Crossbell City for many years. Its leader, Don Marconi, is a friend of Speaker Hartmann, an important figure in Crossbell’s government. This is how Marconi, and his right-hand man, Garcia Rossi, are able to engage so freely in all their criminal acts. 
            </p>
            <p>
                The Crossbell Police Department is well aware of the connection between Hartmann and Marconi, but all of the corrupt politicians and officials these two have under their thumbs has left the poor, poor CPD quite unable to act. 
            </p>
            <p>
                If Revache was to start a war with Heiyue for control of Crossbell’s criminal underground, I would recommend the SSS stay out of it. Lloyd and his little friends are ever so entertaining to watch—it would be such a pity if they were to be crushed like bugs in the conflict.
            </p>
        </div>
    </div>
)

const Heiyue = () => (
    <div className="hacked-wrapper">
        <div className="hacked-title_wrapper">
            <img className="dance" src="./img/field/cat.webp" alt="Stuff Bunny" />
            <h1 className="hacked-title" style={{textAlign: "center"}}>
                Heiyue
            </h1>
            <img className="dance" src="./img/field/bunny.webp" alt="Stuff Bunny" />
        </div>
        <div className="summary-characters">
            <img className="notes-character-image pink" style={{maxHeight: "250px"}} src="./img/characters/cao.webp" alt="Key art of Cao" />
            <img className="notes-character-image pink" style={{maxHeight: "250px"}} src="./img/characters/yin.webp" alt="Key art of Yin" />
        </div>
        <h2 className="summary-title_caption">
            <span data-text="As written by Kitty" className="kitty glitch">
                As written by Kitty
            </span>
            <br/>
            <img className="kitty-logo" src="./img/field/kitty.webp" alt="Kitty Sign" />
        </h2>
        <div className="summary-container">
            <p>
                Hailing from Calvard, Heiyue is a crime syndicate trying to wrestle control of Crossbell’s black market away from Revache. On paper, it’s a simple trading company by the name of Heiyue Trading, Ltd, but this is merely a front for the group’s criminal activities. I’m sure that cunning and tenacious branch manager, Cao Lee, was the one who came up with this idea. 
            </p>
            <p>
                Most of their members’ capabilities are well within my expectations. However, it seems they have one particular individual in their employ who may be a bit more interesting—someone whose name is whispered of in Calvard’s Eastern Quarter. The legendary assassin known only as Yin.
            </p>
            <p>
                If Heiyue was to start a war with Revache for control of Crossbell’s criminal underground, I would recommend the SSS stay out of it. Lloyd and his little friends are ever so entertaining to watch—it would be such a pity if they were to be crushed like bugs in the conflict.
            </p>
        </div>
   </div>
)

export default FieldNotes;